export const paymentCardInfo = {
	payment: "Payment",
	cashPayment: "In cash",
	installmentsPayment: "Installments",
};
